import { Language } from "../types/Types";
import GenericUtil from "../util/Generic";

const LANG_KEY = "selectedLanguage";

const getFirstPreferredLanguage = (): Language => {
  const lang = navigator.language.split("-")[0];
  return (
    GenericUtil.findEnumValue<Language>(Language, lang) || Language.ESPANISH
  );
};


export const saveSelectedLanguage = (language: Language): void => {
  localStorage.setItem(LANG_KEY, language);
};

export const getSelectedLanguage = (): Language => {
  const lang = localStorage.getItem(LANG_KEY) || "";
  return (
    GenericUtil.findEnumValue<Language>(Language, lang) ||
    getFirstPreferredLanguage()
  );
};
